(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-custom-overview"] && !Shopify.designMode) return;
  try {
    
  const CONFIG = {
    ACTIVE_CLASS: 'active',
    SWIPER_SPEED: 600,
    TEXT_ICON_PREFIX: 'text-icon-',
    IMAGE_BOX_PREFIX: 'image-box-',
  };
  const toggleActive = (elems, targetElem) => {
    if (!elems || !targetElem || targetElem.classList.contains(CONFIG.ACTIVE_CLASS)) return;
    elems.forEach((item) => item.classList.remove(CONFIG.ACTIVE_CLASS));
    targetElem.classList.add(CONFIG.ACTIVE_CLASS);
  };
  const getElementIndex = (collection, element) => {
    if (!collection || !element) return -1;
    return Array.from(collection).indexOf(element);
  };
  const debounce = (fn, delay = 100) => {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn && fn(...args);
      }, delay);
    };
  };
  const getSwiperCommonConfig = (classname, withPagination = true, slidesPerView = 'auto') => {
    const config = {
      direction: 'horizontal',
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      loop: false,
      controller: {},
      observer: true, // 监听swiper容器的DOM变化
      observeParents: true, // 监听swiper父级容器的DOM变化
      speed: CONFIG.SWIPER_SPEED,
      on: {},
    };
    if (withPagination) {
      config.pagination = {
        el: `${classname} .swiper-pagination`,
        clickable: true,
      };
      config.navigation = {
        nextEl: `${classname} .carousel-btn-next`,
        prevEl: `${classname} .carousel-btn-prev`,
      };
    }
    return config;
  };

  const controlSwiperVideo = (swiper, targetIndex) => {
    const allSlides = swiper.slides;
    allSlides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (index === targetIndex) video.play().catch((err) => console.log('视频播放失败:', err));
      else video.pause();
    });
  };
  const initSection8 = () => {
    const section8 = document.querySelector('.section-secure');
    if (!section8) return;
    const imageBoxItems = section8.querySelectorAll('.image-box-item');
    const textIconHeads = section8.querySelectorAll('.text-icon-head');
    const productTexts = section8.querySelectorAll('.product-text');
    const handleSection8Click = (e) => {
      const textHeadElem = e.target.closest('.text-icon-head');
      const index = getElementIndex(textIconHeads, textHeadElem);
      if (index === -1) return;
      const currentIndex = index + 1;
      const targetText = section8.querySelector(`.${CONFIG.TEXT_ICON_PREFIX}${currentIndex}`);
      const targetImage = section8.querySelector(`.${CONFIG.IMAGE_BOX_PREFIX}${currentIndex}`);
      toggleActive(productTexts, targetText);
      toggleActive(imageBoxItems, targetImage);
    };
    const handleSection8Resize = () => {
      const activeTexts = section8.querySelectorAll(`.product-text.${CONFIG.ACTIVE_CLASS}`);
      if (!activeTexts.length) return;
      activeTexts.forEach((item, i) => i > 0 && item.classList.remove(CONFIG.ACTIVE_CLASS));
      const firstActiveText = activeTexts[0];
      const activeIndexClass = [...firstActiveText.classList].find((cls) => cls.startsWith(CONFIG.TEXT_ICON_PREFIX));
      if (!activeIndexClass) return;
      const activeIndex = parseInt(activeIndexClass.split('-')[2], 10);
      if (isNaN(activeIndex)) return;
      const targetImage = section8.querySelector(`.${CONFIG.IMAGE_BOX_PREFIX}${activeIndex}`);
      toggleActive(imageBoxItems, targetImage);
    };
    section8.addEventListener('click', handleSection8Click);
    const debouncedResize = debounce(handleSection8Resize);
    window.addEventListener('resize', debouncedResize);
    return () => {
      section8.removeEventListener('click', handleSection8Click);
      window.removeEventListener('resize', debouncedResize);
    };
  };
  const swiper = (classname, slideChangeCallback = null) => {
    const swiperContainer = document.querySelector(`${classname} .swiper`);
    if (!swiperContainer) return null;
    const swiperConfig = getSwiperCommonConfig(classname, true);
    if (typeof slideChangeCallback === 'function') {
      swiperConfig.on.slideChange = (e) => {
        debounce(slideChangeCallback(e.activeIndex, e), 100);
      };
      swiperConfig.on.init = (e) => {
        slideChangeCallback(e.activeIndex, e);
      };
    }
    return new Swiper(swiperContainer, swiperConfig);
  };
  const swiperSection = (classname) => {
    const swiperContainer = document.querySelector(`${classname} .swiper`);
    if (!swiperContainer) return null;
    const swiper7 = new Swiper(swiperContainer, getSwiperCommonConfig(classname, false, 1));
    const paginationBtns = document.querySelectorAll(`${classname} .pagination-btn`);
    const paginationWrap = document.querySelector(`${classname} .swiper-custom-pagination`);
    if (!paginationBtns.length || !paginationWrap) return swiper7;
    let lastActiveIndex = 0;
    const scrollToActiveBtn = (activeIndex) => {
      const activeBtn = paginationBtns[activeIndex];
      if (!activeBtn) return;
      let scrollLeft = activeBtn.offsetLeft - paginationWrap.clientWidth / 6;
      if (activeIndex < lastActiveIndex) scrollLeft += paginationWrap.clientWidth / 6;
      else if (activeIndex > lastActiveIndex) scrollLeft -= paginationWrap.clientWidth / 4;
      const maxScrollLeft = paginationWrap.scrollWidth - paginationWrap.clientWidth;
      scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft));
      paginationWrap.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
      lastActiveIndex = activeIndex;
    };

    swiper7.on('slideChange', function () {
      const currentIndex = this.activeIndex;
      paginationBtns.forEach((btn, index) => {
        btn.classList.toggle(CONFIG.ACTIVE_CLASS, index === currentIndex);
      });
      scrollToActiveBtn(currentIndex);
    });
    paginationBtns.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        swiper7.slideTo(index, CONFIG.SWIPER_SPEED, true);
        scrollToActiveBtn(index);
      });
    });
    return swiper7;
  };
  document.addEventListener('DOMContentLoaded', () => {
    initSection8();
    let swiper1 = null,
      swiper2 = null;
    swiper2 = swiper('.section-mode .swiper2', (activeIndex, swiperIns) => {
      controlSwiperVideo(swiperIns, activeIndex);
      if (swiper1) swiper1.slideTo(activeIndex, CONFIG.SWIPER_SPEED, true);
    });
    swiper1 = swiper('.section-mode .swiper1', (activeIndex) => {
      if (swiper2) swiper2.slideTo(activeIndex, CONFIG.SWIPER_SPEED, true);
    });
    if (swiper1 && swiper2) {
      swiper1.controller.control = swiper2;
      swiper2.controller.control = swiper1;
    }
    swiper('.veloCore-difference-section');
    swiper('.section-effortless');
    swiper('.section-discover');
    swiper('.section-precision');
    swiperSection('.section-smart');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.specs-section').forEach((section) => {
      const toggleBtns = section.querySelectorAll('.specs-toggle-btn');
      const content = section.querySelector('.specs-content');
      const imgContainer = section.querySelector('.specs-img-container');
      const btnLayout = section.dataset.btnLayout || 'two';
      const buttonWrap = section.querySelector('.specs-btn');
      const variantEls = section.querySelectorAll('[data-specs-variant]');
      const variantButtons = section.querySelectorAll('[data-specs-variant-btn]');
      const axisButtons = section.querySelectorAll('[data-specs-axis][data-specs-value]');
      const itemRows = section.querySelectorAll('.flex-row-item, .grid-3-item');

      let activeRow1 = Number(section.dataset.defaultRow1 || 0);
      let activeRow2 = Number(section.dataset.defaultRow2 || 0);
      let activeVariant = Number(section.dataset.defaultVariant || 0);

      const isMeaningfulContent = (el) => {
        if (!el) return false;
        if (el.matches('picture')) return true;
        if (el.querySelector && el.querySelector('img, svg, video')) return true;
        const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
        return text.length > 0;
      };

      const computeAvailableVariants = () => {
        const available = new Set();
        const pictures = imgContainer ? imgContainer.querySelectorAll('picture[data-specs-variant]') : [];
        const anyPictures = pictures.length > 0;
        const pictureByVariant = new Map();
        pictures.forEach((pic) => {
          const idx = Number(pic.dataset.specsVariant);
          if (!Number.isNaN(idx)) pictureByVariant.set(idx, true);
        });

        const countsByVariant = new Map();
        for (let i = 0; i < 4; i++) countsByVariant.set(i, 0);
        itemRows.forEach((row) => {
          for (let i = 0; i < 4; i++) {
            const cell = row.querySelector('[data-specs-variant="' + i + '"]');
            if (isMeaningfulContent(cell)) countsByVariant.set(i, (countsByVariant.get(i) || 0) + 1);
          }
        });

        const requiresInfo = itemRows.length > 0;
        for (let i = 0; i < 4; i++) {
          const hasInfo = !requiresInfo || (countsByVariant.get(i) || 0) > 0;
          const hasPicOk = !anyPictures || pictureByVariant.has(i);
          if (hasInfo && hasPicOk) available.add(i);
        }
        return available;
      };

      const availableVariants = computeAvailableVariants();
      const firstAvailable = () => {
        for (let i = 0; i < 4; i++) if (availableVariants.has(i)) return i;
        return null;
      };
      const normalizeVariant = (requested) => {
        const req = Number(requested);
        if (!Number.isNaN(req) && availableVariants.has(req)) return req;
        return firstAvailable();
      };

      const updateRowVisibility = () => {
        itemRows.forEach((row) => {
          const cell = row.querySelector('[data-specs-variant="' + activeVariant + '"]');
          row.hidden = !isMeaningfulContent(cell);
        });
      };

      const updateButtonVisibility = () => {
        if (!buttonWrap) return;
        const visibleVariants = Array.from(availableVariants.values());
        if (visibleVariants.length < 2) {
          buttonWrap.hidden = true;
          return;
        }
        buttonWrap.hidden = false;

        if (btnLayout === 'matrix') {
          const has00or01 = availableVariants.has(0) || availableVariants.has(1);
          const has10or11 = availableVariants.has(2) || availableVariants.has(3);
          const has00or10 = availableVariants.has(0) || availableVariants.has(2);
          const has01or11 = availableVariants.has(1) || availableVariants.has(3);

          axisButtons.forEach((btn) => {
            const axis = btn.dataset.specsAxis;
            const value = Number(btn.dataset.specsValue);
            let show = true;
            if (axis === 'row1') show = value === 0 ? has00or01 : has10or11;
            if (axis === 'row2') show = value === 0 ? has00or10 : has01or11;
            btn.hidden = !show;
          });
          const axisRows = buttonWrap.querySelectorAll('.specs-btn-row');
          axisRows.forEach((row) => {
            const buttons = row.querySelectorAll('button');
            row.hidden =
              buttons.length > 0 && Array.from(buttons).every((b) => b.hidden);
          });
        } else {
          variantButtons.forEach((btn) => {
            const v = Number(btn.dataset.specsVariantBtn);
            btn.hidden = !availableVariants.has(v);
          });
        }
      };

      const setVariant = (variantIndex) => {
        const normalized = normalizeVariant(variantIndex);
        if (normalized === null) {
          if (buttonWrap) buttonWrap.hidden = true;
          return;
        }
        activeVariant = normalized;
        if (btnLayout === 'matrix') {
          activeRow1 = Math.floor(activeVariant / 2);
          activeRow2 = activeVariant % 2;
        }

        variantEls.forEach((el) => {
          const isActive = Number(el.dataset.specsVariant) === activeVariant;
          el.classList.toggle('specs-show', isActive);
          el.classList.toggle('specs-hide', !isActive);
        });

        variantButtons.forEach((btn) => {
          const isActive = Number(btn.dataset.specsVariantBtn) === activeVariant;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        axisButtons.forEach((btn) => {
          const axis = btn.dataset.specsAxis;
          const value = Number(btn.dataset.specsValue);
          const isActive =
            (axis === 'row1' && value === activeRow1) ||
            (axis === 'row2' && value === activeRow2);
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updateRowVisibility();
        updateButtonVisibility();
      };

      const toggleSection = () => {
        content.classList.toggle('specs-content--expanded');
        content.classList.toggle('specs-content--collapsed');
        toggleBtns.forEach(btn => {
          btn.classList.toggle('specs-toggle-btn--expanded');
          btn.classList.toggle('specs-toggle-btn--collapsed');
        });
        if (imgContainer) imgContainer.classList.toggle('expanded');
      };

      const header = section.querySelector('.specs-header');
      if (header) header.addEventListener('click', toggleSection);
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          toggleSection();
        });
      });
      if (content.classList.contains('specs-content--expanded') && imgContainer) {
        imgContainer.classList.add('expanded');
      }

      variantButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setVariant(Number(btn.dataset.specsVariantBtn));
        });
      });

      axisButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const axis = btn.dataset.specsAxis;
          const value = Number(btn.dataset.specsValue);
          if (axis === 'row1') activeRow1 = value;
          if (axis === 'row2') activeRow2 = value;
          let desired = activeRow1 * 2 + activeRow2;
          if (!availableVariants.has(desired)) {
            if (axis === 'row1') {
              const alt = activeRow1 * 2 + (activeRow2 === 0 ? 1 : 0);
              if (availableVariants.has(alt)) desired = alt;
            }
            if (axis === 'row2') {
              const alt = (activeRow1 === 0 ? 1 : 0) * 2 + activeRow2;
              if (availableVariants.has(alt)) desired = alt;
            }
          }
          setVariant(desired);
        });
      });

      setVariant(activeVariant);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
